module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no-chat-462edd1de1359c96d365ae4d4c1f3380.svg";